import React from "react";
import logo from "../assets/n-logo.png";

const Logo = ({ height = 40, className = "", onClick }) => {
  return (
    <img
      src={logo}
      alt="Nessefy Logo"
      onClick={onClick}
      className={className}
      style={{
        height: `${height}px`,
        width: "auto",
        maxWidth: "140px",
        objectFit: "contain",
        display: "block",
        cursor: "pointer",
      }}
    />
  );
};

export default Logo;
